module.exports = __webpack_public_path__ + "static/_racism-02e7ae254f25198f66d3f54213a67284.jpg";